import React, { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import { getStyles } from "../util/getStyles";

const Heading = (props) => {
  const [textComponent, setTextComponent] = useState("h2");

  useEffect(() => {
    const settings = [props];
    settings.forEach((setting) => {
      if (setting.header_size) {
        if (setting.header_size === "h1") {
          setTextComponent("h1");
        }
        if (setting.header_size === "h2") {
          setTextComponent("h2");
        }
        if (setting.header_size === "h3") {
          setTextComponent("h3");
        }
        if (setting.header_size === "h4") {
          setTextComponent("h4");
        }
        if (setting.header_size === "h5") {
          setTextComponent("h5");
        }
        if (setting.header_size === "h6") {
          setTextComponent("h6");
        }
        if (setting.header_size === "p") {
          setTextComponent("body1");
        }
        if (setting.header_size === "span") {
          setTextComponent("body1");
        }
      }
    });
  }, []);

  return (
    <Typography style={getStyles(props)} variant={textComponent}>
      {props.title}
    </Typography>
  );
};
export default Heading;
